// extracted by mini-css-extract-plugin
module.exports = {"container":"DetailedAddressViewer_container__3D0a9","detailedAddress":"DetailedAddressViewer_detailedAddress__JGXLs","colorFgMain":"DetailedAddressViewer_colorFgMain__kVfda"};